import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/about-banner.jpg';

import aboutprofile from '../assests/img/about-por.jpg';

import gallery01 from '../assests/img/gallery/01.jpeg';
import gallery02 from '../assests/img/gallery/02.jpeg';
import gallery03 from '../assests/img/gallery/03.jpeg';
import gallery04 from '../assests/img/gallery/04.jpeg';
import gallery05 from '../assests/img/gallery/05.jpeg';
import gallery06 from '../assests/img/gallery/06.jpeg';
import gallery07 from '../assests/img/gallery/07.jpeg';
import gallery08 from '../assests/img/gallery/08.jpeg';
import gallery09 from '../assests/img/gallery/09.jpeg';
import gallery10 from '../assests/img/gallery/10.jpeg';
import gallery11 from '../assests/img/gallery/11.jpeg';
import gallery12 from '../assests/img/gallery/12.jpeg';
import gallery13 from '../assests/img/gallery/13.jpeg';
import gallery14 from '../assests/img/gallery/14.jpeg';
import gallery15 from '../assests/img/gallery/15.jpeg';
import gallery16 from '../assests/img/gallery/16.jpeg';
import gallery17 from '../assests/img/gallery/17.jpeg';
import gallery18 from '../assests/img/gallery/18.jpeg';
import gallery19 from '../assests/img/gallery/19.jpeg';
import gallery20 from '../assests/img/gallery/20.jpeg';
import gallery21 from '../assests/img/gallery/21.jpeg';
import gallery22 from '../assests/img/gallery/22.jpeg';
import gallery23 from '../assests/img/gallery/23.jpeg';
import gallery24 from '../assests/img/gallery/24.jpeg';
import gallery25 from '../assests/img/gallery/25.jpeg';
import gallery26 from '../assests/img/gallery/26.jpeg';
import gallery27 from '../assests/img/gallery/27.jpeg';
import gallery28 from '../assests/img/gallery/28.jpeg';
import gallery29 from '../assests/img/gallery/29.jpeg';
import gallery30 from '../assests/img/gallery/30.jpeg';
import gallery31 from '../assests/img/gallery/31.jpeg';
import gallery32 from '../assests/img/gallery/32.jpeg';
import gallery33 from '../assests/img/gallery/33.jpeg';
import gallery34 from '../assests/img/gallery/34.jpeg';






import { Helmet } from 'react-helmet-async';


import 'photoswipe/dist/photoswipe.css'

import { Gallery, Item } from 'react-photoswipe-gallery'

function Gallerypage() {
return (
  <div >

       <Helmet>
        <title>Gallery Labway Scientific | Send an Enquiry</title>
        <meta
          name="description"
          content="Gallery Labway Scientific for laboratory instruments, science kits, educational apparatus, product enquiries, quotations, and support."
        />
        <meta
          name="keywords"
          content="Labway Scientific contact, lab instruments enquiry, educational apparatus contact, science kits quotation, Ambala laboratory supplier"
        />
      </Helmet>
    
  <Header/>
  {/* <Showlist/> */}
  
  {/* <div className='container'>
      <div className='about-banner'>
          <img src={aboutBanner} alt=""/>
      </div>
  </div> */}
  
  <div className='container main-contant'>
    <div className='inner-page-container gallery-page-container'>
      <h1 className='page-title'>Gallery</h1>     
      <div className="gallery-wrap">
       <Gallery>


  <Item 
    className="gallery-item"
    original={gallery01}
    thumbnail={gallery01}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery01} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery02}
    thumbnail={gallery02}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery02} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery03}
    thumbnail={gallery03}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery03} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery04}
    thumbnail={gallery04}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery04} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery05}
    thumbnail={gallery05}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery05} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery06}
    thumbnail={gallery06}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery06} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery07}
    thumbnail={gallery07}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery07} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery08}
    thumbnail={gallery08}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery08} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery09}
    thumbnail={gallery09}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery09} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery10}
    thumbnail={gallery10}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery10} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery11}
    thumbnail={gallery11}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery11} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery12}
    thumbnail={gallery12}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery12} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery13}
    thumbnail={gallery13}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery13} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery14}
    thumbnail={gallery14}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery14} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery15}
    thumbnail={gallery15}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery15} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery16}
    thumbnail={gallery16}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery16} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery17}
    thumbnail={gallery17}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery17} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery18}
    thumbnail={gallery18}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery18} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery19}
    thumbnail={gallery19}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery19} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery20}
    thumbnail={gallery20}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery20} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery21}
    thumbnail={gallery21}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery21} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery22}
    thumbnail={gallery22}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery22} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery23}
    thumbnail={gallery23}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery23} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery24}
    thumbnail={gallery24}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery24} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery25}
    thumbnail={gallery25}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery25} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery26}
    thumbnail={gallery26}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery26} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery27}
    thumbnail={gallery27}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery27} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery28}
    thumbnail={gallery28}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery28} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery29}
    thumbnail={gallery29}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery29} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery30}
    thumbnail={gallery30}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery30} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery31}
    thumbnail={gallery31}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery31} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery32}
    thumbnail={gallery32}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery32} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery33}
    thumbnail={gallery33}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery33} />
    )}
  </Item>

  <Item 
    className="gallery-item"
    original={gallery34}
    thumbnail={gallery34}
    width="1024"
    height="768"
  >
    {({ ref, open }) => (
      <img ref={ref} onClick={open} src={gallery34} />
    )}
  </Item>





  
</Gallery> 
</div>
    </div>
  
  </div>
  <Footer/>
   </div>
    )
}

export default  Gallerypage;
